<template>
	<main class="Dashboard" :class="userSimulated ? 'gap-topAlert' : ''">
		<v-alert
			v-if="showAlert"
			class="Dashboard_alert"
			:type="alertType"
			:dismissible="false"
			>{{ alertMessage }}</v-alert
		>

		<v-alert
			v-if="userSimulated"
			class="Dashboard_alert"
			type="info"
			:dismissible="false"
			>You're logged as {{ this.user.username }}.
			<v-btn
				small
				color="primary"
				class="ml-2"
				@click.prevent="logOutHandler"
				><span>Return to your session</span
				><img
					class="ml-2"
					src="@/assets/img/icon-logout2.svg"
					alt="icon logout" /></v-btn
		></v-alert>

		<Header
			:title="headerTitle"
			:leads="leads"
			:leadsOutbound="leadsOutbound"
			:parent_dates="dates"
			:sites="sites"
			:propertyType="parseInt(propertyType)"
			:leadType="tabActive"
			@getApiLeads="getApiLeads"
		/>

		<div class="wrapper py-5">
			<!-- #TABS NAV -->
			<div
				class="Dashboard_Tabs-nav d-flex"
				v-if="totalVisitors > 0 && showOutbound"
			>
				<button
					@click="tabHandler(leadTypes.INBOUND)"
					class="Dashboard_Tabs-link flex-grow-1"
					:class="tabActive === leadTypes.INBOUND && 'active'"
					type="button"
				>
					<span>Inbound Leads</span>
					<svg
						class="link-melt link-melt-end"
						width="30"
						height="30"
						viewBox="0 0 30 30"
						fill="#ffffff"
						stroke="#e2e2e2"
						stroke-width="1"
					>
						<path d="M -1 -1 C -1 32 32 31 31 31 H -1 Z" />
					</svg>
				</button>
				<button
					@click="tabHandler(leadTypes.OUTBOUND)"
					class="Dashboard_Tabs-link flex-grow-1"
					:class="tabActive === leadTypes.OUTBOUND && 'active'"
					type="button"
				>
					<span>Active Prospects</span>
					<svg
						class="link-melt link-melt-start"
						width="30"
						height="30"
						viewBox="0 0 30 30"
						fill="#ffffff"
						stroke="#e2e2e2"
						stroke-width="1"
					>
						<path d="M 31 -1 C 31 32 -2 31 -1 31 H 31 Z" />
					</svg>
				</button>
			</div>
			<!-- /TABS NAV -->

			<v-card class="Dashboard_Tabs-body pa-5">
				<div
					v-show="tabActive === leadTypes.INBOUND"
					class="Dashboard_Tabs-item"
				>
					<div v-if="propertyIsWeddings">
						<StatsWeddings :dates="dates" :lead_id="lead_id" />
						<TableWeddings :leads="leads" />
					</div>

					<div v-if="!propertyIsWeddings && !propertyIsSocial">
						<StatsMeetings :dates="dates" :lead_id="lead_id" />
						<TableMeetings :leads="leads" />
					</div>

					<div v-if="propertyIsSocial">
						<StatsSocial :dates="dates" :lead_id="lead_id" />
						<TableSocial :leads="leads" />
					</div>
				</div>

				<div
					v-show="tabActive === leadTypes.OUTBOUND"
					class="Dashboard_Tabs-item"
				>
					<StatsOutbound :dates="dates" :lead_id="lead_id" />
					<TableOutbound
						:leads="leadsOutbound"
						:propertyType="parseInt(propertyType)"
					/>
				</div>
			</v-card>
		</div>

		<DialogLeadLost :lead="leadToLost" />

		<DialogLeadDown :lead="leadToTurnDown" />

		<DialogLeadDelete :lead="leadToDelete" />
	</main>
</template>

<script>
import * as dayjs from "dayjs";

import Header from "@/components/Header";
import StatsMeetings from "@/components/StatsMeetings";
import StatsWeddings from "@/components/StatsWeddings";
import StatsSocial from "@/components/StatsSocial";
import TableMeetings from "@/components/TableMeetings";
import TableWeddings from "@/components/TableWeddings";
import TableSocial from "@/components/TableSocial";
import TableOutbound from "@/components/TableOutbound";
import LineChart from "@/components/LineChart";
import BarChart from "@/components/BarChart";
import DialogLeadLost from "@/components/DialogLeadLost";
import DialogLeadDown from "@/components/DialogLeadDown";
import DialogLeadDelete from "@/components/DialogLeadDelete";
import StatsOutbound from "@/components/StatsOutbound";

import { mapGetters, mapActions } from "vuex";
import { BUS_EVENTS, PROPERTIES_TYPES, LEAD_TYPES } from "@/constants";
import { EventBus } from "@/utilities";

export default {
	name: "Dashboard",

	data() {
		return {
			showAlert: false,
			alertType: "info",
			alertMessage: "...",
			leadToLost: null,
			leadToTurnDown: null,
			leadToDelete: null,
			lead_id: null,
			dates: [],
			userSimulated: false,
			leadTypes: LEAD_TYPES,
			tabActive: LEAD_TYPES.INBOUND,
		};
	},
	computed: {
		...mapGetters({
			leads: "StateLeads",
			leadsOutbound: "StateVisitors",
			sites: "StateSites",
			totalInvestment: "StateTotalInvestment",
			propertyType: "StateTypeSelected",
			store_site_id: "StateSiteSeleted",
			user: "StateUser",
			tab: "StateTab",
			totalVisitors: "StateTotalVisitors",
			showOutbound: "StateShowOutbound",
		}),

		headerTitle() {
			switch (parseInt(this.propertyType)) {
				case PROPERTIES_TYPES.SOCIAL:
					return "Social Events Leads Manager";
				case PROPERTIES_TYPES.WEDDINGS:
					return "Weddings Leads Manager";
				case PROPERTIES_TYPES.MEETINGS:
					return "Meetings Leads Manager";
				default:
					return "Leads Manager";
			}
		},
		propertyIsWeddings() {
			return parseInt(this.propertyType) === PROPERTIES_TYPES.WEDDINGS;
		},
		propertyIsSocial() {
			return parseInt(this.propertyType) === PROPERTIES_TYPES.SOCIAL;
		},
	},
	methods: {
		...mapActions(["getLeads", "logOut", "getVisitors"]),

		updatePropertyType(payload) {
			if (payload) {
				//this.$store.commit("setShowOutbound", this.sites.find(site => site.site_id == payload.siteID).showOutbound);
				this.$store.commit("setSiteSelected", parseInt(payload.siteID));
				if (payload.propertyType) {
					this.$store.commit("setTypeSelected", payload.propertyType);
				}
			}
		},

		setLeadToLost(lead = {}) {
			this.leadToLost = lead;
		},
		setLeadToTurnDown(lead = {}) {
			this.leadToTurnDown = lead;
		},
		setShowAlert(ops) {
			this.alertType = ops.type || "info";
			this.alertMessage = ops.message || "...";
			this.showAlert = true;
			setTimeout(() => (this.showAlert = false), ops.duration || 1e3);
		},
		setLeadToDelete(lead) {
			this.leadToDelete = lead;
		},
		setDatesSiteId(newDates) {
			this.dates = newDates;
		},
		async logOutHandler() {
			await this.logOut();
			this.$router.push("/");
		},
		tabHandler(tab) {
			if (tab === "outbound") {
				this.getVisitors({ dates: this.dates, lead_id: this.lead_id });
			} else {
				this.getLeads({ dates: this.dates, lead_id: this.lead_id });
			}
			this.tabActive = tab;

			this.$store.commit("setTab", tab);
		},
		getApiLeads(params) {
			if (this.tabActive === "inbound") this.getLeads(params);
			else this.getVisitors(params);
		},
	},
	async beforeMount() {
		//this.tabActive = this.tab;

		const {
			startDate: pStartDate,
			endDate: pEndDate,
			siteId: pSiteId,
			leadId: pLeadId,
		} = this.$route.params;
		this.lead_id = pLeadId ? pLeadId : null;

		if (pSiteId !== undefined) {
			this.$store.commit("setSiteSelected", parseInt(pSiteId));
			// this.$store.commit(
			// 	"setTypeSelected",
			// 	this.sites.find((site) => site.site_id == pSiteId).property_type
			// );
		}

		this.dates = [
			pStartDate
				? pStartDate
				: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
			pEndDate ? pEndDate : dayjs().format("YYYY-MM-DD"),
		];

		this.userSimulated = this.user.userSimulated;

		EventBus.$on(BUS_EVENTS.DATES_UPDATED, this.setDatesSiteId);
		EventBus.$on(BUS_EVENTS.LEAD_DOWN, this.setLeadToTurnDown);
		EventBus.$on(BUS_EVENTS.LEAD_DELETE, this.setLeadToDelete);
		EventBus.$on(BUS_EVENTS.LEAD_LOST, this.setLeadToLost);
		EventBus.$on(BUS_EVENTS.ALERT_TRIGGERED, this.setShowAlert);
		EventBus.$on(BUS_EVENTS.PTYPE_UPDATED, this.updatePropertyType);
	},
	components: {
		Header,
		TableMeetings,
		TableWeddings,
		TableSocial,
		TableOutbound,
		StatsMeetings,
		StatsWeddings,
		StatsSocial,
		StatsOutbound,
		LineChart,
		BarChart,
		DialogLeadDown,
		DialogLeadDelete,
		DialogLeadLost,
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.Dashboard {
	background: #f7f7f7;
	height: auto;
	min-height: 100vh;
	padding-top: 130px;
	/deep/ &_alert {
		width: 100%;
		border-radius: 0;
		text-align: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		.v-icon {
			display: none;
		}
	}

	&_Tabs {
		&-link {
			background: #cccccc;
			color: #ffffff;
			font-size: 20px;
			font-weight: 600;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			height: auto;
			min-height: 70px;
			padding: 20px;
			border: 1px solid #e2e2e2;
			border-bottom: 0;
			border-radius: 14px 14px 0 0;
			position: relative;
			// transition: background 0.3s;
			&:hover {
				background: $purple;
				/* span {
					opacity: 0.5;
				} */
			}
			&.active {
				background: #ffffff;
				color: $purple;
				position: relative;
				z-index: 2;
				.link-melt {
					display: block;
				}
			}
			.link-melt {
				position: absolute;
				bottom: 0;
				z-index: 1;
				display: none;
				&-start {
					right: 100%;
				}
				&-end {
					left: 100%;
				}
			}
		}
		&-body {
			#app & {
				border-top: 0;
				border-radius: 0 0 4px 4px;
			}
		}
	}
}
/deep/ .statsChart {
	flex: 1 1;
	display: block;
	width: 50%;
	padding: 10px;
	@media screen and (max-width: 1264px) {
		width: 100%;
		max-width: 100%;
	}
	&_label {
		font-size: 13px;
		color: $purple;
		display: block;
		margin-bottom: 5px;
		font-weight: 500;
		line-height: 1;
		@media screen and (max-width: 960px) {
			font-size: 11px;
		}
	}
}
/deep/ .Chart {
	display: block;
	width: 100%;
	height: 100%;
	max-height: 270px;
}
/deep/ .stats_toggle {
	font-size: 13px;
	color: $purple;
	display: inline-block;
	font-weight: 500;
}
.gap-topAlert {
	padding-top: 200px;
	/deep/ .Header {
		margin-top: 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue